// header.js — predictive search + header interactions. Extracted from sections/header.liquid.
// The search URL is read from the header search form (was a Liquid interpolation).

  // 2026-10-12 (own search, no app; research/2026-10-12-filters/OWN-SEARCH.md): tighter keyword search. Shopify's /search
  // matches a word ANYWHERE, description included, so "desk" gave 1,000 results and a price sort opened on 21 non-desks out
  // of 24. Shopify now ignores options[fields] / options[prefix] on /search (measured: identical counts), but it does honour
  // field terms in q. So the words the shopper typed stay as typed (that keeps Shopify's relevance order) and each product
  // word must ALSO be in the title, a tag or the department: "desk" → "desk (title:desk OR tag:desk OR tag:desks OR …)".
  // Describing words (small, modern, cheap…) and sizes ("120cm") are not tightened; colours, shapes and features also match
  // their filter tags (grey → Colour_Grey, corner → Shape_Corner); a few Irish/UK words search their catalogue word too
  // (couch → sofa, hoover → vacuum, press → cupboard, bedside locker → bedside table). The page shows only the typed words
  // (snippets/search-terms-clean.liquid); a tightened search that finds nothing re-runs as a plain one (main-search.liquid).
  window.jxSearchQ = window.jxSearchQ || (function () {
    var STOP = { with: 1, for: 1, and: 1, the: 1, of: 1, in: 1, to: 1, a: 1, an: 1, my: 1, on: 1, set: 1 };
    var LOOSE = 'small,large,big,mini,compact,modern,cheap,cheapest,best,new,wooden,wood,metal,glass,industrial,rustic,vintage,luxury,kids,kid,childrens,children,tall,low,wide,narrow,slim,long,round,square,outdoor,indoor,home,sale,quality,good,nice,heavy,duty,portable,adjustable,extra,space,saving,simple,stylish,cute,pretty,unique,ireland,irish,uk,delivery,free'.split(',');
    var COLOUR = { black: 'Black', white: 'White', grey: 'Grey', gray: 'Grey', brown: 'Brown', blue: 'Blue', cream: 'Cream', beige: 'Cream', green: 'Green', gold: 'Gold', pink: 'Pink', oak: 'Oak', red: 'Red', orange: 'Orange', yellow: 'Yellow', purple: 'Purple' };
    var FTAG = { corner: ['Shape_Corner', 'Shape_L-shaped'], 'l-shaped': ['Shape_L-shaped'], lshaped: ['Shape_L-shaped'], electric: ['Feature_Electric'], drawer: ['Feature_Drawers'], drawers: ['Feature_Drawers'], shelf: ['Feature_Shelves'], shelves: ['Feature_Shelves'], led: ['Feature_LED'], charging: ['Feature_Charging'], usb: ['Feature_Charging'], wheels: ['Feature_Wheels'], folding: ['Feature_Foldable'], foldable: ['Feature_Foldable'], storage: ['Feature_Storage'] };
    // word → other catalogue words for it (prev: only after that word)
    var SYN = { couch: ['sofa', 'settee'], couches: ['sofa', 'settee'], settee: ['sofa', 'couch'], hoover: ['vacuum'], hoovers: ['vacuum'], press: ['cupboard', 'cabinet', 'wardrobe', 'sideboard'], presses: ['cupboard', 'cabinet', 'wardrobe', 'sideboard'], telly: ['tv'], closet: ['wardrobe'], carpet: ['rug'], nightstand: ['bedside'], bedside: ['nightstand'] };
    var SHOE = ['storage', 'cabinet', 'bench', 'organiser', 'shelf', 'stand'], GARDEN = ['set', 'chair', 'table', 'bench', 'lounger', 'sofa', 'bistro'];
    var SYN_AFTER = { locker: { prev: 'bedside', words: ['table', 'nightstand', 'cabinet'] }, lockers: { prev: 'bedside', words: ['table', 'nightstand', 'cabinet'] },
      unit: { prev: 'tv', words: ['stand', 'cabinet'] }, units: { prev: 'tv', words: ['stand', 'cabinet'] },
      rack: { prev: 'shoe', words: SHOE }, racks: { prev: 'shoe', words: SHOE },
      furniture: { prev: 'garden,patio,outdoor', words: GARDEN } };
    function forms(w) {                                        // desk ↔ desks, mattress ↔ mattresses, shelf/shelves via FTAG
      var f = [w];
      if (/ies$/.test(w)) f.push(w.slice(0, -3) + 'y');
      else if (/(ss|x|ch|sh)es$/.test(w)) f.push(w.slice(0, -2));
      else if (/[^s]s$/.test(w) && w.length > 3) f.push(w.slice(0, -1));
      else if (/[^aeiou]y$/.test(w)) f.push(w.slice(0, -1) + 'ies');
      else if (/(ss|x|ch|sh)$/.test(w)) f.push(w + 'es');
      else if (!/s$/.test(w)) f.push(w + 's');
      return f;
    }
    return function (raw, lastOnly) {                        // lastOnly: tighten only the last product word (the no-results retry)
      var q = String(raw || '').trim().replace(/\s+/g, ' ');
      if (!q || /[():"*]|\b(OR|AND|NOT)\b/.test(q)) return q;          // already a field query, or typed by a power user
      var words = q.split(' '), plain = [], clauses = [];
      words.forEach(function (orig, i) {
        var w = orig.toLowerCase().replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, '');
        var prev = i ? words[i - 1].toLowerCase() : '';
        var syn = SYN[w] || (SYN_AFTER[w] && (',' + SYN_AFTER[w].prev + ',').indexOf(',' + prev + ',') > -1 ? SYN_AFTER[w].words : null);
        plain.push(syn ? '(' + [w].concat(syn).join(' OR ') + ')' : orig);
        if (!/^[a-z][a-z-]+$/.test(w) || STOP[w] || LOOSE.indexOf(w) > -1) return;   // sizes, numbers and describing words stay loose
        var parts = [];
        [w].concat(syn || []).forEach(function (s) { forms(s).forEach(function (f) { parts.push('title:' + f, 'tag:' + f, 'product_type:' + f); }); });
        if (COLOUR[w]) parts.push('tag:Colour_' + COLOUR[w]);
        (FTAG[w] || []).forEach(function (t) { parts.push('tag:' + t); });
        clauses.push('(' + parts.join(' OR ') + ')');
      });
      if (lastOnly) clauses = clauses.slice(-1);
      return clauses.length ? plain.join(' ') + ' ' + clauses.join(' ') : q;
    };
  })();
  // Every search form on the page (header desktop + phone, the search page) sends the tightened query. The typed box keeps
  // its words: its name is lent to a hidden copy for this one submit only. The department shortcut (Enter on "desk" opens
  // Desks) runs first and wins; it prevents the submit, which this skips.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/search') === -1) return;
    var inp = f.querySelector('input[name="q"]:not([type="hidden"])');
    if (!inp) return;
    var t = window.jxSearchQ(inp.value);
    if (!t || t === inp.value.trim()) return;
    var h = f.querySelector('input[data-jxq]');
    if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.setAttribute('data-jxq', ''); f.appendChild(h); }
    h.name = 'q'; h.value = t; inp.removeAttribute('name');
    setTimeout(function () { inp.name = 'q'; h.removeAttribute('name'); }, 0);
  });
  window.jxSearchHref = function (href) {              // a "See all results" link → the same tightened query
    try { var u = new URL(href, location.origin), q = u.searchParams.get('q'); if (q) u.searchParams.set('q', window.jxSearchQ(q)); return u.pathname + u.search; } catch (e) { return href; }
  };


// Mobile nav is a left slide-in drawer: toggle the nav + a backdrop + a body scroll-lock
  // together so the page behind it (visible through the right-hand gap) can't scroll.
  (function () {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    var overlay = document.querySelector('[data-mnav-overlay]');
    if (!nav) return;
    // 2026-10-11 (polish re-fix, lane GLOBAL): the department pictures are lazy, so the first time the menu opened some
    // showed as empty grey squares for about a second. The first screen of them (the 8 rooms + the first 3 departments)
    // is fetched as soon as a finger touches Menu (or it gets focus), ahead of the tap; they are small (snippets/mega-menu).
    var warmed = false;
    function warm() {
      if (warmed) return; warmed = true;
      [].slice.call(nav.querySelectorAll('.mega-link__ico')).concat([].slice.call(nav.querySelectorAll('.mnav-row__img'), 0, 3))
        .forEach(function (i) { if (i.loading === 'lazy') i.loading = 'eager'; });
    }
    if (toggle) ['pointerdown', 'touchstart', 'mouseenter', 'focus'].forEach(function (t) { toggle.addEventListener(t, warm, { passive: true }); });
    function setOpen(open) {
      if (open) warm();
      nav.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('mnav-lock', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // 2026-10-09 (G1 r2): keyboard and screen-reader users land inside the menu when it opens (focus on Close),
      // and go back to the Menu button when it closes from the backdrop too (WAI-ARIA dialog pattern).
      if (open) { document.documentElement.classList.remove('jx-hdr-hide'); var c = nav.querySelector('[data-menu-close]'); if (c) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } }, 30); }
    }
    // Tab stays inside the open menu (it covers the whole screen on phones).
    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !nav.classList.contains('is-open')) return;
      var f = [].filter.call(nav.querySelectorAll('a[href], button'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.__closeMobileNav = function () { setOpen(false); };
    window.__openMobileNav = function () { setOpen(true); };   // shared opener (used by the mobile bottom-nav Shop button)
    if (toggle) toggle.addEventListener('click', function () { setOpen(!nav.classList.contains('is-open')); });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); if (toggle) toggle.focus({ preventScroll: true }); });
    var closeBtn = nav.querySelector('[data-menu-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); if (toggle) toggle.focus(); });
  })();
  // Escape closes any open desktop mega-menu panel (they open on hover/focus-within;
  // blurring the focused item collapses the :focus-within panel) and the mobile nav.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.activeElement && document.activeElement.closest && document.activeElement.closest('.mega-item')) {
      document.activeElement.blur();
    }
    if (document.querySelector('[data-mobile-nav].is-open') && window.__closeMobileNav) {
      window.__closeMobileNav();
      var t = document.querySelector('[data-menu-toggle]'); if (t) t.focus();
    }
  });

  // Mobile nav: tap a category to expand its sub-list (accordion). Sub-links navigate.
  document.querySelectorAll('.mobile-nav .mega-link').forEach(function (link) {
    var item = link.closest('.mega-item');
    var panel = item && item.querySelector('.mega-panel');
    // The top-level tap only toggles the accordion, so the category's own collection page
    // was unreachable on mobile (the desktop "Shop all X" lifestyle tile is hidden here).
    // Inject a plain "Shop all X" link at the top of each panel so it's reachable.
    if (panel && !panel.querySelector('.mobile-shopall')) {
      var href = link.getAttribute('href');
      if (href) {
        var sa = document.createElement('a');
        sa.className = 'mobile-shopall';
        sa.href = href;
        // Avoid doubling when the top-level label already starts with "Shop all"
        // (e.g. "Shop All Departments" → don't render "Shop all Shop All Departments").
        var lbl = link.textContent.trim();
        sa.textContent = /^shop all/i.test(lbl) ? lbl : ('Shop all ' + lbl);
        panel.insertBefore(sa, panel.firstChild);
      }
    }
    // 2026-10-09 (G1 r1): screen readers hear whether a department is open (axe/ARIA disclosure pattern).
    if (item && panel) link.setAttribute('aria-expanded', 'false');
    link.addEventListener('click', function (e) {
      if (!item || !panel) return;
      e.preventDefault();
      link.setAttribute('aria-expanded', item.classList.toggle('is-open') ? 'true' : 'false');
    });
  });

  // 2026-10-09 (G1 r3): the "typewriter" search placeholder is gone. The box shows one fixed prompt, "What are you
  // looking for?" (EZ Living, Bargaintown, IKEA), set in sections/header.liquid; the typing showed half words ("Tr",
  // "Try “coff") most of the time and ran a timer every 35 to 70 ms on every page.

  // Predictive-search autocomplete: a suggestions dropdown under the search box,
  // powered by Shopify's /search/suggest.json (no app needed). Debounced, closes on
  // Escape / outside-click, and falls back to the normal search page on submit.
  (function () {
    // The search route comes from the header form action (this file is a static asset,
    // so no Liquid) — both header search forms post to routes.search_url.
    var _searchForm = document.querySelector('form[role="search"]');
    var ALL = (_searchForm && _searchForm.getAttribute('action')) || '/search';
    document.querySelectorAll('[data-search]').forEach(function (box) {
      var input = box.querySelector('[data-search-input]');
      var panel = box.querySelector('[data-search-results]');
      if (!input || !panel) return;
      var timer, last = '';
      var defTpl = box.querySelector('[data-search-default]');
      var defaultHTML = defTpl ? defTpl.innerHTML : '';
      var active = -1;
      function items() { return panel.querySelectorAll('.search-suggest__item, .ps-chip'); }
      function setActive(idx) {
        var els = items(); if (!els.length) { active = -1; return; }
        active = ((idx % els.length) + els.length) % els.length;          // wrap top↔bottom
        els.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
        els[active].scrollIntoView({ block: 'nearest' });
      }
      function close() { panel.hidden = true; panel.innerHTML = ''; active = -1; }
      // pictures, at the top of the empty-search panel. Same localStorage list the homepage strip uses.
      var rvHTML = null;
      function loadRV() {
        if (rvHTML !== null) return Promise.resolve(rvHTML);
        var list = []; try { list = JSON.parse(localStorage.getItem('jshop_rv')) || []; } catch (e) {}
        list = list.slice(0, 6);
        if (!list.length) { rvHTML = ''; return Promise.resolve(''); }
        return Promise.all(list.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (ps) {
          var cards = ps.filter(function (p) { return p && p.available !== false; }).map(function (p) {
            var img = p.featured_image || (p.images && p.images[0]) || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
            return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="96" height="96">' : '') + '<span>' + esc(p.title) + '</span></a>';
          }).join('');
          rvHTML = cards ? '<div class="search-suggest__head">Recently viewed</div><div class="search-suggest__rv">' + cards + '</div>' : '';
          return rvHTML;
        });
      }
      function showDefault() {
        active = -1; if (!defaultHTML) { close(); return; }
        panel.innerHTML = (rvHTML || '') + defaultHTML; panel.hidden = false;
        if (rvHTML === null) loadRV().then(function (h) { if (h && !panel.hidden && !input.value.trim()) panel.innerHTML = h + defaultHTML; });
      }
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      // Fallback only (used when the Liquid-rendered panel below cannot be fetched): the plain JSON
      // suggestions, with small thumbnails and the from-price.
      function render(data) {
        active = -1;
        var r = data && data.resources && data.resources.results;
        var items = (r && r.products) || [];
        if (!items.length) { panel.innerHTML = '<div class="search-suggest__empty">No quick matches. Press Enter for a full search, or <a href="/collections/all">browse all products</a>.</div>'; panel.hidden = false; return; }
        var html = items.slice(0, 7).map(function (it) {
          var src = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          var img = src ? '<img src="' + esc(src) + '" alt="" loading="eager" decoding="async" width="56" height="56">' : '<span class="search-suggest__noimg"></span>';
          var price = it.price ? '<span class="ps-price"><span class="ps-price__now">' + (it.price_max && it.price_max !== it.price_min ? 'From ' : '') + '€' + esc(String(it.price).replace(/\.00$/, '')) + '</span></span>' : '';
          return '<a class="search-suggest__item ps-prod" href="' + esc(it.url) + '">' + img + '<span class="search-suggest__txt"><span class="search-suggest__t">' + esc(it.title) + '</span>' + price + '</span></a>';
        }).join('');
        html += '<a class="search-suggest__all" href="' + esc(window.jxSearchHref(ALL + '?q=' + encodeURIComponent(input.value) + '&type=product')) + '">See all results →</a>';
        panel.innerHTML = html;
        panel.hidden = false;
      }
      // Department match per query (from the panel's data-exact): Enter on "desk" opens the Desks department.
      var exact = {};
      function norm(q) { return String(q || '').trim().toLowerCase().replace(/\s+/g, ' '); }
      function renderPanel(html, q) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var ps = tmp.querySelector('[data-ps]');
        if (!ps) return false;
        exact[norm(q)] = ps.getAttribute('data-exact') || '';
        if (norm(input.value) !== norm(q)) return true;          // a newer query is on its way
        active = -1;
        panel.innerHTML = ps.innerHTML || '<div class="search-suggest__empty">No quick matches. Press Enter for a full search.</div>';
        [].forEach.call(panel.querySelectorAll('a.search-suggest__all, a.ps-chip--q'), function (l) { l.setAttribute('href', window.jxSearchHref(l.getAttribute('href'))); });
        panel.hidden = false;
        return true;
      }
      function go() {
        var q = input.value.trim();
        if (q.length < 2) { showDefault(); return; }
        if (q === last) { if (panel.innerHTML) panel.hidden = false; return; }
        last = q;
        // Shimmer skeleton rows while the suggestions are fetched.
        panel.innerHTML = new Array(4).join('<div class="search-suggest__skel"><span class="s1"></span><span class="s2"></span></div>') + '<div class="search-suggest__skel"><span class="s1"></span><span class="s2"></span></div>';
        panel.hidden = false;
        // unavailable_products=HIDE, not `last`. `last` only sorts sold-out suggestions to the
        // bottom — they are still returned, still clickable, and a shopper reached a sold-out wine
        // rack straight from this dropdown. This panel builds its own markup from suggest.json, so
        // the sold-out hiding in product-card.liquid never applied here; the exclusion has to come
        // from the API itself.
        // Liquid-rendered panel (sections/main-search.liquid, predictive branch): departments, query
        // completions and products with price, RRP and saving. Falls back to the JSON suggestions.
        var base = '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=7&resources[limit_scope]=each&resources[options][unavailable_products]=hide';
        fetch('/search/suggest' + base + '&section_id=main-search', { headers: { 'Accept': 'text/html' } })
          .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
          .then(function (html) { if (!renderPanel(html, q)) throw new Error('no panel'); })
          .catch(function () {
            return fetch('/search/suggest.json' + base, { headers: { 'Accept': 'application/json' } })
              .then(function (res) { return res.json(); })
              .then(function (d) { if (norm(input.value) === norm(q)) render(d); });
          })
          .catch(function () { last = ''; close(); });
          // reset `last` so a network blip doesn't permanently mute suggestions for THIS query
          // (the go() guard skips a re-fetch while q === last).
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(go, 180); });
      input.addEventListener('focus', go);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); input.blur(); return; }
        if (panel.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
        else if (e.key === 'Enter') { var els = items(); if (active >= 0 && els[active]) { e.preventDefault(); window.location.href = els[active].href; } }
      });
      // Enter on a department's exact name ("desk", "desks", "standing desk") opens that department
      // instead of the loose keyword results. Anything else searches as before.
      var form = box.querySelector('form');
      if (form) form.addEventListener('submit', function (e) {
        var url = exact[norm(input.value)];
        if (url) { e.preventDefault(); window.location.href = url; }
      });
      document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
      // 2026-10-09 (G1 r2): the suggestions also close when focus leaves the search box (Tab away, or focus moved by a
      // script), so they can no longer stay open under a menu panel. A click on a suggestion keeps focus inside the box.
      box.addEventListener('focusout', function (e) {
        var to = e.relatedTarget;
        setTimeout(function () { if (!box.contains(document.activeElement) && !(to && box.contains(to))) { panel.hidden = true; active = -1; } }, 120);
      });
    });
  })();

// Desktop mega-menu "hover intent" (2026-09-26). The panels used to open on pure CSS :hover, so
// moving from one menu word to the next crossed the small gap between them, the first panel
// - once a panel is open, moving to another item swaps it instantly (nothing closes in between);
// - opening from closed waits 80ms, so a cursor just passing over the bar doesn't pop panels;
// - leaving the menu closes it after a 250ms grace, so a slightly wobbly path doesn't snap it shut;
// - the panel pictures are fetched on the first touch of the bar, so they never appear blank.
// Keyboard (:focus-within) and the phone menu are unchanged.
(function () {
  var nav = document.querySelector('.header__nav-bar');
  if (!nav || !window.matchMedia) return;
  var mq = window.matchMedia('(min-width: 1024px) and (hover: hover)');
  var items = [].slice.call(nav.querySelectorAll('.mega-item'));
  var open = null, tOpen = 0, tClose = 0, warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    nav.querySelectorAll('.mega-panel img').forEach(function (i) { i.loading = 'eager'; });
    // 2026-10-09 (G1 r3): the room photo in each panel was only fetched when the pointer reached that department, so it
    // showed an empty tile for the first half second. Fetch them all with the tile pictures, on the first approach.
    nav.querySelectorAll('.mega-life[data-bg]').forEach(function (e) { e.style.backgroundImage = "url('" + e.getAttribute('data-bg') + "')"; e.removeAttribute('data-bg'); });
    nav.querySelectorAll('.mega-panel [style*="url("]').forEach(function (e) {
      var m = (e.getAttribute('style') || '').match(/url\(['"]?([^'")]+)/); if (m) { var im = new Image(); im.src = m[1]; }
    });
  }
  function show(it) {
    clearTimeout(tClose);
    if (open === it) return;
    var a = document.activeElement, mi = a && a.closest ? a.closest('.mega-item') : null;
    if (mi && mi !== it && nav.contains(mi)) a.blur();   // a clicked item keeps :focus-within open otherwise
    nav.setAttribute('data-switch', open && it ? '1' : '0');
    if (open) { open.classList.remove('is-open'); exp(open, false); }
    open = it || null;
    if (open) { open.classList.add('is-open'); exp(open, true); document.querySelectorAll('.header [data-search-results]').forEach(function (p) { p.hidden = true; }); }
    nav.classList.toggle('mega-active', !!open);
  }
  // 2026-10-09 (G1 r2): each department link that opens a panel says whether it is open (aria-expanded), for mouse
  // (hover intent above) and keyboard (focus inside the item) alike.
  function exp(it, v) { var l = it && it.querySelector('.mega-link'); if (l && it.querySelector('.mega-panel')) l.setAttribute('aria-expanded', v ? 'true' : 'false'); }
  items.forEach(function (it) { exp(it, false); });
  nav.addEventListener('focusin', function (e) { var it = e.target.closest && e.target.closest('.mega-item'); if (it) exp(it, true); });
  nav.addEventListener('focusout', function (e) { var it = e.target.closest && e.target.closest('.mega-item'); if (it && !(e.relatedTarget && it.contains(e.relatedTarget)) && it !== open) exp(it, false); });
  items.forEach(function (it) {
    it.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      warm(); clearTimeout(tOpen); clearTimeout(tClose);
      if (open) show(it); else tOpen = setTimeout(function () { show(it); }, 80);
    });
  });
  nav.addEventListener('mouseenter', function () { clearTimeout(tClose); });
  // Fetch the panel pictures early: when the mouse enters the header (on its way to the menu).
  // Desktop/hover devices only, so phones never pay for it, and visitors who never reach the menu don't either.
  var hdr = nav.closest('header') || document.querySelector('.header');
  if (hdr) hdr.addEventListener('mouseenter', function () { if (mq.matches) warm(); });
  // the pointer crosses the top bar first on its way down from the browser's address bar, so start there too
  var bar = document.querySelector('[data-ann]');
  if (bar) bar.addEventListener('mouseenter', function () { if (mq.matches) warm(); });
  nav.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(function () { show(null); }, 250); });
  nav.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.mega-panel a')) show(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') show(null); });
  window.addEventListener('scroll', function () { if (open && window.scrollY > 400) show(null); }, { passive: true });
  document.documentElement.classList.add('js-mega');
})();

// Phone header search icon (2026-10-04, mobile space). On home/collection/search pages the box is already under the
// header: the icon just focuses it. Elsewhere it opens that same box (predictive search included) as an overlay under
// the header row with the input focused; a tap outside, Escape or the icon again closes it. focus() runs inside the tap
// (iOS ignores a deferred focus and would not raise the keyboard), then the focus event is re-sent on the next frame so
// the zero-query suggestions show even if a stray outside-click close fired.
(function () {
  var btn = document.querySelector('[data-search-open]');
  var hdr = document.querySelector('.header');
  var wrap = document.getElementById('hdr-msearch');
  if (!btn || !hdr || !wrap) return;
  var input = wrap.querySelector('[data-search-input]');
  function isOpen() { return hdr.classList.contains('is-search-open'); }
  function setOpen(o) { hdr.classList.toggle('is-search-open', o); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); }
  btn.addEventListener('click', function (ev) {
    ev.preventDefault(); ev.stopPropagation();
    if (isOpen()) { setOpen(false); return; }
    if (getComputedStyle(wrap).display === 'none') setOpen(true);
    if (!input) return;
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    requestAnimationFrame(function () { try { input.dispatchEvent(new Event('focus')); } catch (e) {} });
    if (window.scrollY > 0 && hdr.getBoundingClientRect().top < 0) window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.addEventListener('click', function (e) { if (isOpen() && !wrap.contains(e.target) && !btn.contains(e.target)) setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { setOpen(false); btn.focus(); } });
})();

// 2026-10-09 (G1 r2): the header comes back when you scroll up (phone and desktop). It was meant to be sticky, but
// position:sticky on .header never took effect inside its own section wrapper, so search and the basket scrolled away
// for good. Now the section wrapper is sticky (base.css) and slides up out of view while you scroll down, then slides
// back as soon as you scroll up: the "partially persistent" header NN/g recommends (nngroup.com/articles/sticky-headers),
// and what 6 of 8 Irish reference stores do by keeping the header on screen (references/ie-eu/library.md 3.2).
// Transform only (no layout change, so no layout shift). It never hides while the menu, search or a menu panel is open,
// or while focus is inside the header.
(function () {
  var hdr = document.querySelector('.header');
  var sec = hdr && hdr.parentElement;
  if (!sec || sec === document.body) return;
  var root = document.documentElement, lastY = window.scrollY, hidden = false, ticking = false;
  function topBar() { var t = document.getElementById('shopify-section-trust-bar'); return t ? t.offsetHeight : 0; }
  function busy() {
    if (document.body.classList.contains('mnav-lock')) return true;
    if (hdr.classList.contains('is-search-open') || document.querySelector('.header__nav-bar.mega-active')) return true;
    var a = document.activeElement; return !!(a && a !== document.body && hdr.contains(a));
  }
  function set(h) { if (h === hidden) return; hidden = h; root.classList.toggle('jx-hdr-hide', h); }
  function run() {
    ticking = false;
    var y = Math.max(0, window.scrollY), d = y - lastY;
    if (y <= topBar() + hdr.offsetHeight) { set(false); lastY = y; return; }
    if (Math.abs(d) < 8) return;
    if (d > 0 && !busy()) set(true); else if (d < 0) set(false);
    lastY = y;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
  hdr.addEventListener('focusin', function () { set(false); });
})();
